/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    SAVE: 'Salva',
    SUBMIT: 'Invia'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Errore nella cancellazione della contropartita',
    COUNTERPART_DETAILS_SUBMIT: 'Errore nell\'invio della contropartita',
    DELETE_ATTACHMENT: 'Errore nell\'eliminazione dell\'allegato',
    DELETE_LINK: 'Errore nell\'eliminazione del link',
    ERROR: 'Errore',
    FILE_SIZE: 'Il file non può essere più grande di 8MB',
    MAX_FILES_UPLOAD: 'Non è possibile caricare più di 8MB alla volta',
    PUBLISHED_AT_ERROR: 'Data di pubblicazione obbligatoria'
  },
  HEADER: {
    APPROVED_BY: 'Approvata da',
    ATTACHMENT: 'Allegati',
    COMMENT: 'Commento',
    CONFIRMATION_DATE: 'Conferma',
    CURRENT_PARTNER_TASKS: 'Partner attuale',
    DESCRIPTION: 'Descrizione',
    END_DATE: 'Data di fine',
    LINK: 'Link',
    MANAGER_COMMENT: 'Commento del responsabile',
    MONTH: 'Mese',
    PERIODICITY: 'Frequenza',
    PREVIOUS_PARTNER_TASKS: 'Partner precedente',
    REQUIRED: 'Obbligatorio',
    START_DATE: 'Data di inizio',
    STATE: 'Stato',
    SUBMISSION_DATE: 'Invio'
  },
  LABEL: {
    ATTACHMENTS: 'Allegati',
    ATTACHMENTS_UPLOADED: 'Allegati caricati',
    CANCEL_COUNTERPART: 'Annulla',
    CLOSE: 'Chiudi',
    COMMENT: 'Commento',
    CONFIRM: 'Conferma',
    DESCRIPTION: 'Descrizione',
    FILTER_MONTH_APR: 'Aprile',
    FILTER_MONTH_AUG: 'Agosto',
    FILTER_MONTH_DEC: 'Dicembre',
    FILTER_MONTH_FEB: 'Febbraio',
    FILTER_MONTH_JAN: 'Gennaio',
    FILTER_MONTH_JUL: 'Luglio',
    FILTER_MONTH_JUN: 'Giugno',
    FILTER_MONTH_MAR: 'Marzo',
    FILTER_MONTH_MAY: 'Maggio',
    FILTER_MONTH_NOV: 'Novembre',
    FILTER_MONTH_OCT: 'Ottobre',
    FILTER_MONTH_SEP: 'Settembre',
    LINK: 'Link',
    LINKS: 'Link',
    LINKS_UPLOADED: 'Link caricati',
    MONTH: 'Mese',
    PUBLISHED_AT: 'Data di pubblicazione',
    STATE: 'Stato',
    SUBMIT_COUNTERPART: 'Invia',
    YEAR: 'Anno'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      'Sei sicuro di voler cancellare l\'invio della contropartita?',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      'Sei sicuro di voler inviare la contropartita?',
    NO_ROWS_ATTACHMENT: 'Nessuna allegati'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Allegato cancellato',
    CANCEL_COUNTERPART: 'Contropartita cancellata',
    COUNTERPART_DETAILS_SUBMIT:
      'Dettagli della contropartita inviato con successo',
    LINK_DELETED: 'Link cancellato',
    SUCCESS: 'Successo'
  },
  TOOLTIP: {
    ADD_LINK: 'Aggiungi link',
    APPROVED_BY: 'Approvata da',
    ATTACHMENT: 'Allegati',
    COMMENT: 'Commento',
    CONFIRMATION_DATE: 'Data della conferma',
    CURRENT_PARTNER_TASKS:
      'Numero di registri del periodo attuale che il partner deve inviare',
    DESCRIPTION: 'Descrizione',
    END_DATE: 'Data di fine',
    LINK: 'Link',
    MANAGER_COMMENT: 'Commento del responsabile',
    MONTH: 'Mese',
    PERIODICITY: 'Frequenza',
    PREVIOUS_PARTNER_TASKS:
      'Numero di registri del periodo precendente che il partner deve inviare',
    REMOVE_LINK: 'Cancella link',
    REQUIRED: 'Obbligatorio',
    START_DATE: 'Data di inizio',
    STATE: 'Stato',
    SUBMISSION_DATE: 'Data di invio'
  }
};
